import { Check, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { passwordChecks, passwordStrength } from "@/lib/passwordStrength";

const BAR_TONE = { error: "bg-destructive", warning: "bg-warning", success: "bg-success", muted: "bg-muted" };
const TEXT_TONE = { error: "text-destructive", warning: "text-warning", success: "text-success", muted: "text-muted-foreground" };

// Reusable strength meter + live requirement checklist (display only).
export function PasswordStrength({ value, testidPrefix = "pw" }) {
  const { score, label, tone } = passwordStrength(value);
  const checks = passwordChecks(value);
  return (
    <div className="space-y-2" data-testid={`${testidPrefix}-strength`}>
      <div className="flex items-center gap-2">
        <div className="flex flex-1 gap-1" aria-hidden="true">
          {[0, 1, 2, 3].map((i) => (
            <span key={i} className={cn("h-1.5 flex-1 rounded-full transition-colors",
              value && i < score ? BAR_TONE[tone] : "bg-border")} />
          ))}
        </div>
        <span className={cn("w-20 text-right text-xs font-medium", TEXT_TONE[tone])} data-testid={`${testidPrefix}-strength-label`}>{label}</span>
      </div>
      <ul className="grid grid-cols-1 gap-1 sm:grid-cols-2">
        {checks.map((c) => (
          <li key={c.id} className={cn("flex items-center gap-1.5 text-xs", c.met ? "text-success" : "text-muted-foreground")} data-testid={`${testidPrefix}-req-${c.id}`}>
            {c.met ? <Check className="h-3.5 w-3.5 shrink-0" /> : <X className="h-3.5 w-3.5 shrink-0 opacity-50" />}
            {c.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
